import React, { FC, memo } from 'react';
import classes from './practiceCarousel.module.css';
import joy_girl from 'static/materials/joy_girl.png';
import osusume from 'static/materials/osusume.png';

export const FifthView: FC = memo(() => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div style={{ width: '20%' }}>
          <img src={joy_girl} alt="" width="60%"></img>
        </div>
        <div style={{ width: '80%' }}>
          <div className={classes.yellowBorder}>ステップ1. 練習する！</div>
        </div>
      </div>
      <div style={{ marginTop: '16px' }}>
        <img src={osusume} alt="" width="82%"></img>
      </div>
    </>
  );
});
